module.exports = __webpack_public_path__ + "static/media/sort-numeric-up-alt.449c14e3.svg";